// 求人検索モーダル -----
document.addEventListener("DOMContentLoaded", () => {
	const openButtons = document.querySelectorAll(".js-job-modal-open");
	const closeButtons = document.querySelectorAll(".js-modal-close");
	const modals = document.querySelectorAll(".job-modal");
	const overlay = document.querySelector(".c-overlay");
	const overlayOwner = "job-modal";

	if (!openButtons.length || !modals.length || !overlay) {
		return;
	}

	const closeModal = () => {
		modals.forEach((modal) => {
			modal.classList.remove("is-active");
			modal.setAttribute("aria-hidden", "true");
		});

		removeOverlay(overlay, overlayOwner);
	};

	openButtons.forEach((button) => {
		button.addEventListener("click", () => {
			const targetId = button.dataset.modalTarget;
			const targetModal = targetId ? document.getElementById(targetId) : modals[0];

			if (!targetModal) {
				return;
			}

			modals.forEach((modal) => {
				modal.classList.remove("is-active");
				modal.setAttribute("aria-hidden", "true");
			});

			targetModal.classList.add("is-active");
			targetModal.setAttribute("aria-hidden", "false");
			addOverlay(overlay, overlayOwner);

			const closeButton = targetModal.querySelector(".js-modal-close");
			if (closeButton) {
				closeButton.focus();
			}
		});
	});

	closeButtons.forEach((button) => {
		button.addEventListener("click", closeModal);
	});

	overlay.addEventListener("click", () => {
		if (overlay.dataset.overlayOwner === overlayOwner) {
			closeModal();
		}
	});

	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape") {
			closeModal();
		}
	});
});

// 給与セレクト切り替え -----
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll("[data-salary-options]").forEach((form) => {
		const salaryMin = form.querySelector('select[name="salary_min"]');
		const salaryMax = form.querySelector('select[name="salary_max"]');
		const salaryTypes = form.querySelectorAll('input[name="salary_type"]');

		if (!salaryMin || !salaryMax || !salaryTypes.length) {
			return;
		}

		let salaryOptions = {};

		try {
			salaryOptions = JSON.parse(form.dataset.salaryOptions || "{}");
		} catch (error) {
			return;
		}

		const createOption = (value, label) => {
			const option = document.createElement("option");
			option.value = value;
			option.textContent = label;

			return option;
		};

		const formatYen = (value) => `${Number(value).toLocaleString()}円`;

		const updateSelect = (select, values, emptyLabel) => {
			select.replaceChildren(createOption("", emptyLabel));

			values.forEach((value) => {
				select.appendChild(createOption(String(value), formatYen(value)));
			});
		};

		const updateSalaryOptions = () => {
			const checkedType = form.querySelector('input[name="salary_type"]:checked');
			const type = checkedType ? checkedType.value : "hourly";
			const options = salaryOptions[type] || { min: [], max: [] };

			updateSelect(salaryMin, options.min || [], "下限なし");
			updateSelect(salaryMax, options.max || [], "上限なし");
		};

		salaryTypes.forEach((salaryType) => {
			salaryType.addEventListener("change", updateSalaryOptions);
		});

		updateSalaryOptions();
	});
});

// 条件検索フォーム 送信先URL切り替え -----
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".job-modal__form").forEach((form) => {
		form.addEventListener("submit", (event) => {
			event.preventDefault();

			const formData = new FormData(form);
			const location = String(formData.get("location") || "").trim();
			const salaryMin = String(formData.get("salary_min") || "").trim();
			const salaryMax = String(formData.get("salary_max") || "").trim();
			const params = new URLSearchParams();
			const appendValues = (name) => {
				formData.getAll(name).forEach((value) => {
					const normalizedValue = String(value).trim();

					if (normalizedValue) {
						params.append(name, normalizedValue);
					}
				});
			};

			if (salaryMin || salaryMax) {
				appendValues("salary_type");
				appendValues("salary_min");
				appendValues("salary_max");
			}

			appendValues("tours[]");
			appendValues("qualifications[]");
			appendValues("skills[]");
			appendValues("shifts[]");
			appendValues("features[]");
			appendValues("keyword");

			const baseUrl = location ? `${window.location.origin}/${location}/` : `${window.location.origin}/jobs/`;
			const query = params.toString();

			window.location.href = query ? `${baseUrl}?${query}` : baseUrl;
		});
	});
});
